import React, { useCallback, useState } from 'react';
import { useActiveAuthProvider, useGetIdentity } from '@refinedev/core';
import { Layout as AntdLayout, Typography, Space, Popover } from 'antd';
import type { RefineThemedLayoutHeaderProps } from '@refinedev/antd';
import UserDetails from './userDetails';
import './header.css';
import { DownOutlined, WalletOutlined } from '@ant-design/icons';
import { useUserDetails } from '../../pages/auth/components/auth/hooks';
import { Link } from 'react-router-dom';

const { Text } = Typography;

export const ThemedHeader: React.FC<RefineThemedLayoutHeaderProps> = () => {
  const authProvider = useActiveAuthProvider();
  const { data: user } = useGetIdentity({
    v3LegacyAuthProviderCompatible: Boolean(authProvider?.isLegacy),
  });
  const { userId } = useUserDetails();
  const [openUserDetails, setOpenUserDetails] = useState(false);
  const authorized = user && user.email;

  const onOpenChange = useCallback((open: boolean) => {
    setOpenUserDetails(open);
  }, []);

  if (!authorized) {
    return null;
  }

  return (
    <AntdLayout.Header className={'header'}>
      <Link style={{ marginRight: 40, color: 'white' }} to='/wallet'>
        <WalletOutlined /> Wallet
      </Link>
      <Space>
        <Popover
          content={<UserDetails />}
          trigger='click'
          arrow={false}
          overlayInnerStyle={{ borderRadius: '2px', padding: 0 }}
          placement={'bottomLeft'}
          open={openUserDetails}
          onOpenChange={onOpenChange}
        >
          <Space className={'header-user'} size='middle'>
            <Text className={'header-identity'}>{`ID ${user.id} • ${userId}`}</Text>
            <span>
              <DownOutlined
                className={`header-user__dropdown-icon ${openUserDetails && 'header-user__dropdown-icon--open'}`}
              />
            </span>
          </Space>
        </Popover>
      </Space>
    </AntdLayout.Header>
  );
};
